import { useState, useCallback, FormEvent } from 'react';

import { useTranslator } from '@picsart/rc/services/localization';

import useAnalytics from '~/services/AnalyticsService';
import SvgIcon from '~/components/SvgIcon/SvgIcon';
import useLocation from '~/hooks/useLocation';
import { ANALYTICS } from '~/utils/Constants';

import useSearchFormLargeStyles from './SearchFormLargeJSS';

const { EVENT_NAME, SCREEN_NAMES } = ANALYTICS;

type SearchFormPropsModel = {
  placeholderText?: string;
};

function SearchForm({ placeholderText }: SearchFormPropsModel) {
  const [input, setInput] = useState('');
  const classes = useSearchFormLargeStyles();
  const { sendEvent } = useAnalytics();
  const translate = useTranslator();
  const { baseOrigin } = useLocation();

  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setInput(event.target.value);
    },
    [],
  );
  const handleSubmit = useCallback(
    (event: FormEvent) => {
      event.preventDefault();
      if (input.trim()) {
        window.location.href = `${baseOrigin}/search/?s=${input}`;
        setInput('');
      }
    },
    [input, baseOrigin],
  );

  function handleFieldFocus() {
    sendEvent(EVENT_NAME.searchFieldFocus, {
      origin: SCREEN_NAMES.blog,
    });
  }

  return (
    <div className={classes.root}>
      <form className={classes.form} onSubmit={handleSubmit}>
        <button
          className={classes.searchButton}
          type="button"
          aria-label="search"
          onClick={handleSubmit}
        >
          <SvgIcon name="search-gen" className={classes.searchIcon} />
        </button>
        <input
          className={classes.searchInput}
          type="text"
          name="search"
          placeholder={placeholderText || translate('Search')}
          onChange={handleChange}
          value={input}
          onFocus={handleFieldFocus}
        />
      </form>
    </div>
  );
}

export default SearchForm;
